import React from 'react';
import Table from '../common/Table';
import { ListingFileDTO } from '../../services/apiClient';
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime';
import ImageLink from '../common/ImageLink';
import ImagePreview from '../common/ImagePreview';

interface ListingFileTableProps {
  data: ListingFileDTO[];
  handleEdit?: (row: ListingFileDTO) => void;
  handleDelete?: (row: ListingFileDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const ListingFileTable: React.FC<ListingFileTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        {
          label: 'Preview',
          key: 'preview',
          width: '80px',
          render: (row: ListingFileDTO) => (
            <ImagePreview
              fileId={row.fileId}
              size="sm"
            />
          ),
        },
        {
          label: 'File',
          key: 'fileId',
          render: (row: ListingFileDTO) => (
            <ImageLink
              fileId={row.fileId ?? ''}
              label="View Full Image"
            />
          ),
        },
        {
          label: 'Main',
          key: 'isMain',
          render: (row: ListingFileDTO) => (
            <span
              className={`inline-block px-2 py-1 text-xs font-bold rounded ${
                row.isMain
                  ? 'bg-green-100 text-green-700'
                  : 'bg-yellow-100 text-yellow-700'
              }`}
            >
              {row.isMain ? "Main" : "Not Main"}
            </span>
          ),
        },
        {
          label: 'Added',
          key: 'createdUtc',
          format: (value: Date) => {
            if(value)
              return convertToUserTime(value?.toString() ?? '')
            else
              return 'Not saved'
          }
        },
      ]}
      data={data}
      actions={handleEdit && handleDelete ? {
        onEdit: handleEdit,
        onDelete: handleDelete,
      } : undefined}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default ListingFileTable;
